export default __webpack_public_path__ + "static/media/5t.3600fc74.jpg";